module.exports = __webpack_public_path__ + "static/img/nume__ro-7.2a71677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nume__ro-7.jpg
// module id = jP9s
// module chunks = 0